module.exports = __webpack_public_path__ + "static/media/blue-plus.26ba9783.svg";